import * as React from 'react';
import {STATUS} from "../../types/enums";

interface Props {
    status: number
    appointedStatus: 'appointed' | 'confirmed' | 'refused' | 'public'
    onVisibleDialogs: (name: string) => () => void
    onAppointmentRequest: (name: string) => () => void
}

const resolvedStatuses = [15, 30, 40, 50]

const MentorActions = ({status, appointedStatus, onVisibleDialogs, onAppointmentRequest}: Props) => {
    const isProcessing = STATUS[status] === 'Processing' || STATUS[status] === 'InProgress';
    const isConfirmed = appointedStatus === 'confirmed'
    const isPublic = appointedStatus === 'public'
    const isAppointed = appointedStatus === 'appointed'
    const isRefused = appointedStatus === 'refused'

    if (!resolvedStatuses.includes(status)) {
        return null
    }

    return (
        <div>
            {(isPublic || isAppointed || isRefused || !isConfirmed) && (
                <button
                    className="btn btn-sm pull-right btn-success"
                    onClick={onAppointmentRequest('appointmentRequest')}
                >
                    Назначить мне
                </button>
            )}
            {(isPublic || isAppointed || isConfirmed) && (
                <button
                    className="btn btn-sm pull-right btn-danger"
                    onClick={onVisibleDialogs('rejectRequest')}
                >
                     {resolvedStatuses.includes(status) && isConfirmed ? 'Завершить работу' : 'Отказаться'}
                </button>
            )}
        </div>
    );
};

export default MentorActions;
